import React from 'react';

interface Props {
  size?: number;
  color?: string;
}

const MagnifyingGlassIcon: React.FC<Props> = ({ size = 14, color = 'currentColor' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="7" cy="7" r="4.5" />
    <line x1="10.2" y1="10.2" x2="14" y2="14" />
    {/* Plus sign inside lens for "zoom in" */}
    <line x1="5" y1="7" x2="9" y2="7" />
    <line x1="7" y1="5" x2="7" y2="9" />
  </svg>
);

export default MagnifyingGlassIcon;
